import type { Messages } from './messages';

/**
 * Copy for `src/app/defaults/` — what a المنشأة gets when it set nothing of its
 * own. Owned by that page's author. Every key starts with `defaults.`.
 */
export const defaults = {
  'defaults.title': 'الإعدادات الافتراضية',
  'defaults.subtitle': 'ما تأخذه كل منشأة لم تضبط شيئًا لنفسها. ما تضبطه المنشأة لنفسها يبقى لها ولا يتأثر بما هنا.',

  /* The default email look */
  'defaults.look.title': 'مظهر البريد الافتراضي',
  'defaults.look.description':
    'الشعار والألوان والتذييل لكل رسالة من منشأة ليست لها هوية بريد خاصة بها. يصل أثره موظفي كل عميل من هذا النوع من الإرسال التالي، والمنشأة التي ضبطت هويتها لا تتأثر.',
  'defaults.look.readOnly':
    'للاطلاع فقط: تعديل المظهر الافتراضي للمشرف الأعلى للمنصّة وحده، لأنه يغيّر شكل البريد الذي يصل موظفي كل عميل.',
  'defaults.look.state': 'الحالة',
  'defaults.look.unset': 'غير مضبوط — يُستخدم المظهر المدمج في المنصّة',
  'defaults.look.set': 'مضبوط',
  'defaults.look.updated': 'آخر تعديل',
  'defaults.look.never': 'لم يُعدَّل قط',
  'defaults.look.whereTenant': 'هوية منشأة بعينها تُضبط من تبويب «البريد» ← «القوالب» داخل المنشأة.',

  'defaults.look.logoUrl': 'رابط الشعار',
  'defaults.look.logoUrlHint': 'عنوان https لصورة يصل إليها بريد المستلم دون تسجيل دخول. فارغ = بلا شعار، وتظهر كلمة المنصّة.',
  'defaults.look.brandColor': 'لون العلامة',
  'defaults.look.brandColorHint': 'خلفية الزر.',
  'defaults.look.headerColor': 'لون الترويسة',
  'defaults.look.headerColorHint': 'عنوان الرسالة والكلمة في الترويسة. الترويسة بيضاء، فاختر لونًا داكنًا.',
  'defaults.look.buttonTextColor': 'لون نص الزر',
  'defaults.look.buttonTextColorHint': 'يجب أن يُقرأ فوق لون العلامة.',
  'defaults.look.builtIn': 'فارغ = لون المظهر المدمج.',
  'defaults.look.pick': 'اختيار {field}',
  'defaults.look.useBuiltIn': 'اللون المدمج',
  'defaults.look.footerTitle': 'عنوان التذييل',
  'defaults.look.footerTitleHint': 'السطر الصغير تحت البطاقة. 200 حرف على الأكثر.',
  'defaults.look.footerNote': 'ملاحظة التذييل',
  'defaults.look.footerNoteHint': 'السطر داخل البطاقة تحت الفاصل. 400 حرف على الأكثر.',
  'defaults.look.contrastButton': 'نص الزر فوق لون العلامة تباينه {ratio}:1 — أقل من 4.5:1، فيصعب قراءته في بريد كل منشأة تتبع هذا المظهر.',
  'defaults.look.contrastHeader': 'عنوان الرسالة بهذا اللون فوق الخلفية البيضاء تباينه {ratio}:1 — أقل من 4.5:1. اختر لونًا أغمق.',

  'defaults.look.save': 'حفظ المظهر الافتراضي',
  'defaults.look.saved': 'حُفظ المظهر الافتراضي. يُطبَّق على رسائل المنشآت التي لا هوية لها من الإرسال التالي.',
  'defaults.look.discard': 'تجاهل التغييرات',
  'defaults.look.unsaved': 'تعديلات لم تُحفظ',
  'defaults.look.invalid': 'فيه حقل يحتاج تصحيحًا',
  'defaults.look.clean': 'لا تعديلات',
  'defaults.look.clear': 'مسح المظهر الافتراضي',
  'defaults.look.clearTitle': 'مسح المظهر الافتراضي؟',
  'defaults.look.clearConsequence':
    'تعود رسائل كل منشأة ليست لها هوية خاصة إلى المظهر المدمج في المنصّة من الإرسال التالي. الرسائل المرسلة سابقًا لا تتغير.',
  'defaults.look.clearAffected': 'موظفو كل منشأة لم تضبط هوية بريد خاصة بها.',
  'defaults.look.cleared': 'مُسح المظهر الافتراضي، وعاد المظهر المدمج.',
  'defaults.look.noPreview': 'لا معاينة هنا: المعاينة تُبنى لقالب منشأة بعينها. افتح «القوالب» في منشأة بلا هوية خاصة لترى هذا المظهر على رسالة حقيقية.',

  'defaults.error.hex': 'اللون ثلاث أو ست خانات ست عشرية، مثل ⁦#00587C⁩.',
  'defaults.error.footerTitleLong': 'عنوان التذييل أطول من 200 حرف.',
  'defaults.error.footerNoteLong': 'ملاحظة التذييل أطول من 400 حرف.',
  'defaults.error.logoHttps': 'رابط الشعار يجب أن يبدأ بـ ⁦https://⁩.',

  'defaults.leave.title': 'تجاهل التعديلات غير المحفوظة؟',
  'defaults.leave.consequence': 'لم يُحفظ ما عدّلته على المظهر الافتراضي. إن غادرت الآن ضاع، ويبقى المحفوظ كما هو.',
  'defaults.leave.confirm': 'تجاهل ومغادرة',
} as const satisfies Messages<'defaults'>;
